import React, { useState } from "react";
import { ChevronDown, HelpCircle } from "lucide-react";
import { faqs } from "../data/mock";

const defaultItems = faqs.map((f) => ({ q: f.question, a: f.answer }));

const FAQ = ({
  items = defaultItems,
  badge = "Veelgestelde vragen",
  title = "Antwoorden op de meest gestelde vragen",
  subtitle = "Staat uw vraag er niet bij? Neem gerust contact op — we beantwoorden u meestal binnen een dag.",
}) => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section
      id="faq"
      className="py-24 bg-white"
      aria-labelledby="faq-heading"
      data-testid="faq-section"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-flex items-center space-x-2 px-4 py-1 bg-sky-100 text-sky-700 rounded-full text-sm font-semibold mb-4">
            <HelpCircle className="w-4 h-4" />
            <span>{badge}</span>
          </span>
          <h2 id="faq-heading" className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-800 mb-4">
            {title}
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">{subtitle}</p>
        </div>

        <div className="space-y-3">
          {items.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={faq.q}
                className={`bg-white border rounded-2xl shadow-sm transition-all ${
                  isOpen ? "border-sky-200 shadow-md" : "border-slate-200"
                }`}
                data-testid={`faq-item-${index}`}
              >
                <button
                  className="w-full flex items-start justify-between p-5 sm:p-6 text-left"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  aria-expanded={isOpen}
                  aria-controls={`faq-answer-${index}`}
                  data-testid={`faq-question-${index}`}
                >
                  <span className="font-semibold text-slate-800 text-base sm:text-lg pr-4">{faq.q}</span>
                  <ChevronDown
                    className={`w-5 h-5 flex-shrink-0 text-sky-600 transition-transform ${isOpen ? "rotate-180" : ""}`}
                  />
                </button>
                {isOpen && (
                  <div
                    id={`faq-answer-${index}`}
                    className="px-5 sm:px-6 pb-5 sm:pb-6 text-slate-600 leading-relaxed"
                    data-testid={`faq-answer-${index}`}
                  >
                    {faq.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="text-center mt-12">
          <p className="text-slate-600 mb-4">Andere vraag of meteen een offerte?</p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href="#contact"
              className="inline-flex items-center justify-center px-6 py-3 bg-white border-2 border-sky-500 text-sky-600 rounded-xl font-semibold hover:bg-sky-50 transition-colors"
              data-testid="faq-contact-btn"
            >
              Stel uw vraag
            </a>
            <a
              href="#calculator"
              className="inline-flex items-center justify-center px-6 py-3 bg-gradient-to-r from-sky-500 to-teal-500 text-white rounded-xl font-semibold hover:from-sky-600 hover:to-teal-600 transition-all shadow-lg shadow-sky-500/25"
              data-testid="faq-calculator-btn"
            >
              Bereken direct uw prijs
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
